import { useEffect } from "react";
import { useData, useDispatch } from "./DataContext.js";

import Button from "react-bootstrap/Button";

import MainNavbar from "./MainNavbar.js";
import TitlePage from "./TitlePage.js";
import Report from "./Report.js";
import Themes from "./Themes.js";
import TitleModal from "./TitleModal.js";
import EndModal from "./EndModal.js";
import CompanyModal from "./CompanyModal.js";
import MapModal from "./MapModal.js";
import DialogueModal from "./DialogueModal.js";
import ReportModal from "./ReportModal.js";
import ReportResultModal from "./ReportResultModal.js";
import ReportApplicationModal from "./ReportApplicationModal.js";
import InformationModal from "./InformationModal.js";
import ItemModal from "./ItemModal.js";

const CHEAT = false;

export default function Play (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    function cheat ()
    {
	let time = 0;
	const badgeIds = ["indice_1", "indice_2", "indice_3"];
	const badges = badgeIds.map((badgeId) => { return { id: badgeId, state: "opened", time: time++ }; });
	gDispatch({ type: "addBadges", badges });
    }

    useEffect(() => {
	if (gData.gameId === "ada" && gData.state.currentThemeId === null) gDispatch({ type: "startTheme", themeId: gData.content.params.startThemeId });
    }, [gData.gameId, gData.state.currentThemeId, gData.state.params, gData.content, gDispatch]);
    
    useEffect(() => {
	if (gData.state.currentThemeId === null) return;
	const themeContent = gData.content.themes[gData.state.currentThemeId];
	const timeLeft = themeContent.endTime - gData.state.time;

	let alertDone = false;
	let lastAlertTime = gData.state.themes[gData.state.currentThemeId].alertTime;
	if (timeLeft <= 0 && (lastAlertTime === undefined || 0 < lastAlertTime))
	{
	    let alertContent = gData.content.themes[gData.state.currentThemeId].timeoutMessage || "C'est l'heure de rendre votre rapport !";
	    gDispatch({ type: "alertTime", time: 0, data: { variant: "danger", title: "Le temps est écoulé", content: alertContent } });
	    alertDone = true;
	}

	[[30, "une demi-heure"], [60, "une heure"]].forEach(([alertTime, alertTimeStr]) => {
	    if (! alertDone && timeLeft <= alertTime && (lastAlertTime === undefined || alertTime < lastAlertTime))
	    {
		alertDone = true;
		gDispatch({ type: "alertTime", time: alertTime, data: { variant: "warning", title: "Attention au temps", content: "Il vous reste " + alertTimeStr + " avant de rendre votre rapport." } });
	    }
	});

    }, [gData.state.currentThemeId, gData.state.time, gData.state.themes, gData.content, gDispatch])


    // RENDER
    return (
	<>
	    {gData.state.currentThemeId === null && (
		<TitlePage>
		    <Themes/>
		</TitlePage>
	    )}
	    {gData.state.currentThemeId !== null && (
		<div className="vh-100">
		    <MainNavbar isFullscreen={props.isFullscreen}/>
		    <DialogueModal/>
		    {CHEAT && (<Button variant="outline-light" className="position-absolute bottom-0 end-0 m-2" onClick={cheat}>Cheat!</Button>)}
		</div>
	    )}
	    <Report/>
	    <CompanyModal/>
	    <MapModal/>
	    <ReportModal/>
	    <ReportResultModal/>
	    <ReportApplicationModal/>
	    <InformationModal/>
	    <ItemModal/>
	    <TitleModal/>
	    <EndModal/>
	</>
    );
}
